<template>
  <div style="border-radius: 9px" class="pa-4 white">
    <div class="mb-4">
      <div class="d-flex flex-wrap" style="gap: 8px">
        <div class="main-toolbar">
          <div class="icon-back">
            <v-img
              src="../../../assets/figmaIcons/white/big-data.svg"
              max-width="55%"
            ></v-img>
          </div>
          <span class="main-toolbar-title">Big Data Dashboard</span>
        </div>

        <v-spacer></v-spacer>
        <div class="d-flex align-center" style="gap: 8px">
          <div>
            <v-select
              :items="groups"
              v-model="selectedGroup"
              item-text="name"
              item-value="id"
              placeholder="Grupos de Filtros"
              @change="applySelectedGroup"
              class="primary-input mb-0"
              outlined
              hide-details
            >
            </v-select>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="openManageDialog"
                class="primary-button mx-0"
                style="height: 46px !important"
                color="primary"
                small
              >
                <v-icon>mdi-filter-cog-outline</v-icon>
              </v-btn>
            </template>
            <span>Gerenciar Grupos de Filtros</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <v-tabs grow color="secondary" v-model="reportTab">
      <v-tab
        v-for="(page, id) in reportPages"
        :key="id"
        @click="report.setPage(page.name)"
      >
        {{ page.displayName }}
      </v-tab>
    </v-tabs>

    <div :key="containerKey" id="reportContainer"></div>

    <div class="mt-4">
      <div class="d-flex mb-4 align-end">
        <strong class="ml-2">Análises:</strong>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" color="primary" depressed @click="openAddDialog">
          Adicionar texto
        </v-btn>
      </div>
    </div>

    <div class="mt-4">
      <v-col
        cols="12"
        class="d-flex align-center justify-center mb-2 flex-wrap"
      >
        <v-menu
          ref="startMenu"
          :close-on-content-click="false"
          :return-value.sync="filter.startDate"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              append-icon="mdi-calendar"
              class="primary-button mr-0"
              style="text-transform: none"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              {{ `${formatMonth(filter.startDate)}` }}
            </v-btn>
          </template>
          <v-date-picker
            v-model="filter.startDate"
            type="month"
            :locale="$i18n.locale"
            no-title
            scrollable
            @change="$refs.startMenu.save(filter.startDate), getTexts()"
          >
          </v-date-picker>
        </v-menu>

        <span class="mx-2 subtitle"> até </span>

        <v-menu
          ref="endMenu"
          :close-on-content-click="false"
          :return-value.sync="filter.endDate"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              append-icon="mdi-calendar"
              class="primary-button mr-0"
              style="text-transform: none"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              {{ `${formatMonth(filter.endDate)}` }}
            </v-btn>
          </template>
          <v-date-picker
            v-model="filter.endDate"
            type="month"
            :locale="$i18n.locale"
            no-title
            scrollable
            @change="$refs.endMenu.save(filter.endDate), getTexts()"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
    </div>

    <div class="my-4">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        no-data-text="Nenhuma análise encontrada"
        :headers="headers"
        :items="items"
        item-key="id"
        class="main-table"
        hide-default-footer
        :items-per-page="filter.pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
      >
        <template #[`item.reportDate`]="{ item }">
          <span class="text-uppercase">{{ formatMonth(item.reportDate) }}</span>
        </template>

        <template #[`item.actions`]="{ item }">
          <v-btn
            class="mr-2"
            tile
            color="#f5f5f5"
            style="border-radius: 10px; background-color: #f5f5f5"
            rounded
            icon
            depressed
            @click="openViewDialog(item)"
          >
            <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
          </v-btn>

          <v-btn
            class="secondary-button ml-2"
            depressed
            tile
            rounded
            icon
            @click="openEditDialog(item)"
          >
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>

          <v-btn
            class="ml-2"
            color="#921616"
            depressed
            style="border-radius: 10px; background-color: #921616"
            icon
            @click="openRemoveDialog(item)"
          >
            <v-icon color="white" small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <v-dialog v-model="removeDialog" max-width="300">
      <v-card class="pa-4">
        <h2 class="text-center">Remover análise</h2>
        <p class="text-center">
          Tem certeza de que deseja remover esta análise?
        </p>

        <div class="d-flex">
          <v-btn color="primary" depressed @click="removeDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="mr-0"
            color="secondary"
            @click="remove"
            :loading="loading"
          >
            Remover
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewDialog" max-width="850">
      <v-card class="pa-4">
        <h2 class="text-center">Visualização de análise</h2>

        <v-row class="ma-0" justify="center" dense>
          <v-col cols="12" v-if="analysis.author">
            <div>
              <strong>Autor: </strong> <span>{{ analysis.author.name }}</span>
            </div>
            <div>
              <strong>E-mail do Autor: </strong>
              <span>{{ analysis.author.email }}</span>
            </div>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1"> Mês da análise: </label>
            <div class="d-flex">
              <div
                class="primary white--text"
                style="
                  border-radius: 10px;
                  width: 100%;
                  height: 30px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-transform: uppercase;
                "
              >
                {{ formatMonth(analysis.reportDate) }}
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1">Texto de análise:</label>
            <div
              class="pa-4"
              style="border: 1px solid #ccc; border-radius: 6px"
              v-html="analysis.text"
            ></div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="manageDialog" max-width="850">
      <v-card class="pa-4" flat>
        <h2 class="text-center">
          {{ analysis.id ? 'Editar' : `Adicionar` }} registro
        </h2>

        <v-form ref="form">
          <v-row class="ma-0" justify="center" dense>
            <v-col cols="12">
              <label class="label ml-1"> Mês da análise: </label>
              <div class="d-flex">
                <v-menu
                  ref="startMenu"
                  :close-on-content-click="false"
                  :return-value.sync="analysis.reportDate"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      append-icon="mdi-calendar"
                      class="primary-button mr-0"
                      style="text-transform: none"
                      readonly
                      block
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ `${formatMonth(analysis.reportDate)}` }}
                    </v-btn>
                  </template>
                  <v-date-picker
                    v-model="analysis.reportDate"
                    type="month"
                    :locale="$i18n.locale"
                    no-title
                    scrollable
                    @change="$refs.startMenu.save(analysis.reportDate)"
                  >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>

            <v-col cols="12">
              <label class="label ml-1">Texto de análise:</label>
              <tiptap-vuetify
                v-model="analysis.text"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                :extensions="extensions"
                :label="$t('Análise')"
                :placeholder="$t('Digite suas análises aqui')"
                :card-props="{ flat: true, outlined: true, rounded: true }"
                class="primary-input"
                outlined
                dense
                hide-details="auto"
              ></tiptap-vuetify>
            </v-col>
          </v-row>
        </v-form>

        <div class="d-flex">
          <v-btn color="primary" depressed @click="manageDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="mr-0"
            color="secondary"
            @click="submit"
            :loading="loading"
          >
            {{ analysis.id ? 'Editar' : `Adicionar` }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="manageDialogFilterGroup" max-width="800px">
      <v-card>
        <v-card-title class="d-flex flex-wrap">
          <h2 style="font-size: 21px">Grupos de Filtros</h2>
          <v-spacer></v-spacer>
          <div>
            <v-icon
              style="font-size: 32px !important"
              @click="manageDialogFilterGroup = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>

        <label class="label px-6"> Gerencie o grupo de filtro desejado </label>

        <v-card-text class="pt-0">
          <v-data-table
            :loading="loadingGroups"
            :loading-text="$t('Carregando...')"
            no-data-text="Ainda não há grupos"
            :headers="groupHeaders"
            :items="groups"
            class="main-table"
            hide-default-footer
            :single-expand="true"
            show-expand
          >
            <template v-slot:expanded-item="{ item }">
              <td :colspan="headers.length">
                <div class="d-flex align-center justify-center py-4">
                  <span
                    ><span class="font-weight-medium">Instituições: </span>
                    {{
                      item.filters
                        .map((institution) =>
                          getInstitutionNameById(institution)
                        )
                        .join(' | ')
                    }}</span
                  >
                </div>
              </td>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                class="ma-1"
                small
                depressed
                color="#0f3565"
                @click="openEditGroupDialog(item)"
              >
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                class="ma-1"
                small
                depressed
                color="#ff4f64"
                @click="deleteGroup(item)"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button ma-1 mb-4"
            color="secondary"
            depressed
            @click="openAddGroupDialog"
          >
            Criar novo grupo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja excluir este grupo?
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="ma-1" color="error" text @click="confirmDelete()"
            >Excluir</v-btn
          >
        </v-sheet>
      </div>
    </v-dialog>

    <v-form ref="form">
      <ManageFilterGroup
        :dialog.sync="manageFilterGroupDialog"
        :currentGroup="currentGroup"
        :institutions="institutions"
        :isEditing="isEditing"
        @save-group="saveGroup"
        @reset-group="resetGroup"
      />
    </v-form>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'
import ApiService from '../../../services/ApiService'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

import moment from 'moment'
import ManageFilterGroup from './components/ManageFilterGroup.vue'

export default {
  data() {
    return {
      removeDialog: false,
      page: 1,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      totalItensOnPage: null,
      totalItems: null,
      totalPages: null,
      viewDialog: false,
      analysis: {
        id: null,
        reportDate: null,
        type: null,
        text: null,
        authorId: null,
      },
      manageDialog: false,
      loading: false,
      items: [],
      types: [
        {
          text: 'Preventiva',
          value: 0,
        },
        {
          text: 'Calibração',
          value: 1,
        },
        {
          text: 'Segurança Elétrica',
          value: 2,
        },
        {
          text: 'Corretiva',
          value: 3,
        },
      ],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Autor',
          align: 'center',
          value: 'author.name',
          sortable: false,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'reportDate',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      report: null,
      reportTab: 0,
      reportPages: [],
      apiService: new ApiService(),
      tokens: {},
      filter: {
        page: 1,
        pageSize: 10,
        startDate: null,
        endDate: null,
        type: 0,
      },
      manageDialogFilterGroup: false,
      groups: [],
      institutions: [],
      institutionsChecked: [],
      currentGroup: {
        name: '',
        filters: [],
      },
      groupHeaders: [
        { text: 'Nome do Grupo', align: 'center', value: 'name' },
        { text: 'Ações', align: 'center', value: 'actions', sortable: false },
      ],
      selectedGroup: null,
      institutionName: null,
      loadingGroups: false,
      addForm: false,
      manageFilterGroupDialog: false,
      isEditing: false,
      containerKey: 0,
      deleteDialog: false,
    }
  },

  components: {
    TiptapVuetify,
    ManageFilterGroup,
  },

  created() {
    this.resetDate()
    this.loggedUserId = JSON.parse(localStorage.getItem('user')).id

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.fetchGroups()
    this.getInstitutions()
  },

  async mounted() {
    await this.getToken()
    await this.mountedBi()
    this.getTexts()
  },

  methods: {
    openRemoveDialog(item) {
      this.analysis = item
      this.removeDialog = true
    },

    remove() {
      this.apiService
        .delete('bigDataDashboardText/remove?id=' + this.analysis.id)
        .then((response) => {
          this.getTexts()
          this.$toast.success('Análise removida com sucesso!')
          this.removeDialog = false
        })
    },

    getAnalysisType(analysis) {
      const find = this.types.find((x) => x.value == analysis.type)

      if (find) {
        return find.text
      } else {
        return 'Sem registro'
      }
    },

    openViewDialog(item) {
      this.analysis = item
      this.viewDialog = true
    },

    resetDate() {
      this.analysis.reportDate = moment()
        .add(-1, 'month')
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')
    },

    openEditDialog(item) {
      this.analysis = item

      this.manageDialog = true
    },

    openAddDialog() {
      this.analysis = {
        authorId: this.loggedUserId,
        reportDate: moment()
          .add(-1, 'month')
          .clone()
          .startOf('month')
          .format('YYYY-MM-DD'),
        text: null,
        type: this.reportTab,
      }

      this.manageDialog = true
    },

    submit() {
      if (this.$refs.form.validate()) {
        const model = this.analysis
        this.loading = true

        if (model.id) {
          this.apiService
            .post('bigDataDashboardText/edit', model)
            .then((response) => {
              this.getTexts()
              this.$toast.success('Análise atualizada com sucesso!')
              this.loading = false
              this.manageDialog = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.apiService
            .post('bigDataDashboardText/add', model)
            .then((response) => {
              this.getTexts()
              this.$toast.success('Análise registrada com sucesso!')
              this.loading = false
              this.manageDialog = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getToken() {
      await this.apiService
        .get(
          'consumptionReading/getAccessToken?reportId=3f2a01ca-abf7-4efe-b5cf-b03797703e2f&datasetId=60bd760e-25de-4e41-a01f-45ced8216ecf'
        )
        .then((response) => {
          this.tokens = response.content
        })
    },

    getTexts() {
      this.filter.type = this.reportTab
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize

      this.apiService
        .post('bigDataDashboardText/list', this.filter)
        .then((response) => {
          this.items = response.content.data
          this.totalItems = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.totalItensOnPage = response.content.data.length
        })
    },

    openManageDialog() {
      this.manageDialogFilterGroup = true
    },

    fetchGroups() {
      this.loadingGroups = true
      this.apiService
        .get('ManagerFilterBI')
        .then((response) => {
          this.groups = response.content
          this.loadingGroups = false
        })
        .catch(() => {
          this.loadingGroups = false
        })
    },

    async getInstitutions() {
      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
        })
        .catch((err) => {})
    },

    saveGroup() {
      if (this.$refs.form.validate()) {
        if (this.isEditing) {
          this.apiService.put(`ManagerFilterBI`, this.currentGroup).then(() => {
            this.fetchGroups()
            this.manageFilterGroupDialog = false
          })
        } else {
          this.apiService
            .post(`ManagerFilterBI`, this.currentGroup)
            .then(() => {
              this.fetchGroups()
              this.manageFilterGroupDialog = false
            })
        }
        this.fetchGroups()
      }
    },

    deleteGroup(group) {
      this.currentGroup = group
      this.deleteDialog = true
    },

    confirmDelete() {
      this.apiService
        .delete(`ManagerFilterBI/${this.currentGroup.id}`)
        .then(() => {
          this.deleteDialog = false
          this.fetchGroups()
        })
    },

    getInstitutionNameById(id) {
      const institution = this.institutions.find((inst) => inst.id === id)
      return institution ? institution.name : 'Desconhecido'
    },

    openAddGroupDialog() {
      this.resetGroup()
      this.isEditing = false
      this.manageFilterGroupDialog = true
    },

    openEditGroupDialog(group) {
      this.currentGroup = { ...group }
      this.isEditing = true
      this.manageFilterGroupDialog = true
    },

    resetGroup() {
      this.currentGroup = {
        name: '',
        filters: [],
      }
      this.$refs.form.resetValidation()
    },

    async applySelectedGroup(groupId) {
      const selectedGroup = this.groups.find((group) => group.id === groupId)
      if (selectedGroup) {
        this.reportTab = 0
        this.selectedGroup = selectedGroup
        this.institutionName = selectedGroup.filters.map((institution) =>
          this.getInstitutionNameById(institution)
        )
        this.mountedBi()
      }
    },

    async mountedBi() {
      try {
        const institutionsName = this.institutionName

        const powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        )

        let models = pbi.models

        const basicFilter = {
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'institutions',
            column: 'Name',
          },
          operator: 'In',
          values:
            institutionsName && institutionsName.length > 0
              ? institutionsName
              : [],
          filterType: 1,
        }

        let reportContainer = document.getElementById('reportContainer')
        powerbi.reset(reportContainer)

        let embedConfiguration = {
          type: 'report',
          id: '3f2a01ca-abf7-4efe-b5cf-b03797703e2f',
          embedUrl:
            'https://app.powerbi.com/reportEmbed?reportId=3f2a01ca-abf7-4efe-b5cf-b03797703e2f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1CLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3D',
          tokenType: models.TokenType.Embed,
          accessToken: this.tokens.token,
          permissions: models.Permissions.All,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: false,
          },
        }

        this.report = powerbi.embed(reportContainer, embedConfiguration)

        const self = this

        this.report.on('loaded', (event) => {
          this.report.getFilters().then(async (filters) => {
            if (basicFilter.values && basicFilter.values.length > 0)
              filters.push(...[basicFilter])

            self.reportPages = await self.report.getPages()
            self.report.setPage(self.reportPages[0].name)
            return self.report.setFilters(filters)
          })
        })
      } catch (err) {
        console.error(err)
      }
    },
  },

  watch: {
    reportTab() {
      this.page = 1
      this.getTexts()
    },
    page() {
      this.getTexts()
    },
    pageSize() {
      this.getTexts()
    },
  },
}
</script>

<style scoped>
#reportContainer {
  height: 70vh;
  width: 100% !important;
}
</style>
